export const createDashboardFixedCacheKey =
  "postUsersMeOrganisationsCurrentDashboards-fixed-cache-key";

export const updateDashboardFixedCacheKey =
  "putUsersMeOrganisationsCurrentDashboardsByDashboardId-fixed-cache-key";

export const createWidgetFixedCacheKey =
  "postUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgets-fixed-cache-key";
